import { LegacyCard, Page } from "@shopify/polaris";
import { useContext, useRef } from "react";
import ToastContext from "../../../context/ToastContext";
import { SET_ERROR, SET_OK } from "../../../context/ToastReducer";
import { createRole } from "../../../services/rolesService";
import ListRoles from "../../UI/Users/ListRoles"
import { NewRoleModal } from "../../UI/Users/NewRoleModal";

const ViewRoles = (props) => {
    const [, dispatchToast] = useContext(ToastContext);
    const listRoles = useRef();

    const createNewRole = (form) => {
        return createRole(form)
          .then((r) => {
            dispatchToast({ type: SET_OK, payload: r.data });
            listRoles.current.renew();
          })
          .catch((e) => {
            dispatchToast({ type: SET_ERROR, payload: e.response.data });
            throw new Error(e.response.data);
          });
      };

    return (
        <Page title="Roles de usuario"
        // primaryAction={<NewUserModal onAddUser={(e) => createNewUser(e)} />}
        primaryAction={<NewRoleModal onAddRole={createNewRole} />}
         divider>
            <LegacyCard>
                <ListRoles ref={listRoles} />
            </LegacyCard>
        </Page>
    );
}

export default ViewRoles;